"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEOSRequestConfig = void 0;
var _AxiosRequestConfigWithAuth = require("../common/AxiosRequestConfigWithAuth");
const isEOSRequestConfig = function (config) {
  return (0, _AxiosRequestConfigWithAuth.isAxiosRequestConfigWithAuth)(config) || "includeReCaptcha" in config || "OAuth" in config || "service" in config;
};
exports.isEOSRequestConfig = isEOSRequestConfig;